module.exports = __webpack_public_path__ + "assets/b90f8fc45acea7328f88536ddd61dda0.jpg";